import { useState } from 'react';
import { Icon, type IconSize } from '../../icons';
import { Image } from '../../image';

const thumbnailPixelsByIconSize: Partial<Record<IconSize, number>> = {
  large: 40,
  middle: 24,
};

type P = {
  imageFileFallback?: string;
  imagePreview?: boolean;
  size: IconSize;
  type: string;
  url?: string;
};

const ContentFileIcon = ({ imageFileFallback, imagePreview = true, size, type, url }: P) => {
  const thumbnailDimension = thumbnailPixelsByIconSize[size] ?? thumbnailPixelsByIconSize.middle;

  // TODO: if url was error and it has changed to correct state without unmount, this component will always be stucked in error state
  const [hasError, setHasError] = useState(false);

  switch (type) {
    case 'audio':
      return <Icon icon="audio-file" size={size} />;
    case 'image':
      return url ? (
        <Image
          borderRadius="small"
          height={thumbnailDimension}
          key={url}
          objectFit="cover"
          onError={() => {
            setHasError(true);
          }}
          preview={imagePreview ? { mask: <Image.PreviewIcon /> } : false}
          src={hasError && imageFileFallback ? imageFileFallback : url}
          width={thumbnailDimension}
        />
      ) : (
        <Icon icon="img-file" size={size} />
      );
    case 'video':
      return <Icon icon="video-file" size={size} />;
    default:
      return <Icon icon="default-file" />;
  }
};

export default ContentFileIcon;
